import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

/**
 * Lamborghini cart/checkout: show "N year(s) with unlimited mileage" from plan term strings
 * (e.g. yearsMileage / planTermSKUName like "2 YEARS, 999,999 MILES").
 */
@Pipe({ name: "lamboUnlimitedMileageTerm", standalone: false })
export class LamboUnlimitedMileageTermPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(yearsMileage: string | null | undefined): string {
    const years = parseLamboTermYears(yearsMileage);
    if (years === 1) {
      return this.translate.instant("CART_CHECKOUT.LAMBO_UNLIMITED_ONE_YEAR");
    }
    return this.translate.instant("CART_CHECKOUT.LAMBO_UNLIMITED_N_YEARS", { years });
  }
}

export function parseLamboTermYears(yearsMileage: string | null | undefined): number {
  if (!yearsMileage || typeof yearsMileage !== "string") {
    return 1;
  }
  const match = yearsMileage.trim().match(/^(\d+)/);
  if (!match) {
    return 1;
  }
  const n = parseInt(match[1], 10);
  return Number.isFinite(n) && n > 0 ? n : 1;
}
